<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
  -->
<mat-progress-spinner mode="indeterminate" [diameter]="size"></mat-progress-spinner>
